import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget } from '@eforall/dashboard';
import { AppService, DomainDataService } from '../../../../../services';
import { ReadonlyAccessWidget } from '../../../readonly-access/readonly-access.widget';
import { EntrepreneurProspectDialogDataService } from '../entrepreneur-prospect-dialog-data.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'entrepreneur-prospect-dialog-applications-part',
	standalone: true,
	imports: [GridContentWidget, ReadonlyAccessWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './applications.part.html',
})
export class EntrepreneurProspectDialogApplicationsPart {

	public dialogBodyHeight = input.required<number>();

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	public readonly dialogDataService = inject(EntrepreneurProspectDialogDataService);
	private readonly domainData = inject(DomainDataService);
	private readonly appService = inject(AppService);

	public setup = getSetup(this.util, this.appService, this.domainData, this.dialogDataService, this.dialogService);

	// subtracting 70 to account for padding and tabstrip, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 70 - (this.dialogDataService.isReadonly() ? 45 : 0));

	public applications = computed(() => this.dialogDataService.dialogData()?.applications ?? []);
}